<template>
  <div class="search-bar-tags hidden lg:flex gap-x-2 justify-center py-2">
    <span
      v-for="tag in tags"
      :key="tag.label"
      class="bg-[#fff] text-[#2b2b2b] text-[8px] lg:text-base border-[1px] border-[#194165]"
    >
      <a :href="tag.linkPath">
        <!-- <i class="fa fa-search pr-1"></i> -->
        <img :src="searchIcon" alt="search Icon" class="pr-1" />
        {{ tag.label }}
      </a>
    </span>
  </div>
</template>

<script setup>
/* SearchBarTags.vue */
import { searchTags } from "@/client/const/searchTags.js";
import searchIcon from "@/client/assets/images/SearchComponent/search_icon.svg";
import useCustomer from "@/client/store/Customer";
import { ref } from "vue";

const store = useCustomer();
const groupAreas = ref([]);
const tags = ref([]);

const init = async () => {
  groupAreas.value = store.getListGroupArea;
  if (!groupAreas.value.length) {
    groupAreas.value = await store.fetchListGroupArea();
  }
  
  tags.value = searchTags.map((tag) => {
    if(tag.linkPath) {
        return tag;
    }
    const groupArea = groupAreas.value.find((area) => area.slug === tag.groupAreaSlug);

    const childIds = (Array.isArray(groupArea?.child) ? groupArea?.child : Object.values(groupArea?.child || {}))
      .map((child) => child.id)
      .join(",");

    return {
      ...tag,
      linkPath: `search?ar=${childIds}`,
    };
  });
};

init();
</script>

<style lang="scss">
.search-bar-tags span {
  border-radius: 6px;
  padding: 2px 10px;

  @media (max-width: 1100px) {
    padding: 0px 5px;
  }
}

.search-bar-tags span a {
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  line-height: normal;
}
</style>
